module.exports = __webpack_public_path__ + "img/sort-active.5b99a67e.svg";